import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

import appSlice from './slices/appSlice';
import usersSlice from './slices/usersSlice';
import treatmentPlansSlice from './slices/treatmentPlansSlice';
import notificationsSlice from './slices/notificationsSlice';
import librarySlice from './slices/librarySlice';
import customActivitiesSlice from './slices/customActivitiesSlice';
import statisticsSlice from './slices/statisticsSlice';
import refreshPatientsMiddleware from './middlewares/refreshPatients';
import refreshPatientTreatmentPlansMiddleware from './middlewares/refreshPatientTreatmentPlans';
import casesSlice from './slices/casesSlice';
import emrSlice from './slices/emrSlice';
import emrLinkSlice from './slices/emrLinkSlice';

const store = configureStore({
  reducer: {
    appState: appSlice.reducer,
    usersState: usersSlice.reducer,
    treatmentPlansState: treatmentPlansSlice.reducer,
    notificationsState: notificationsSlice.reducer,
    libraryState: librarySlice.reducer,
    customActivitiesState: customActivitiesSlice.reducer,
    statisticsState: statisticsSlice.reducer,
    casesState: casesSlice.reducer,
    emrState: emrSlice.reducer,
    emrLinkState: emrLinkSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      refreshPatientsMiddleware(),
      refreshPatientTreatmentPlansMiddleware(),
    ]),
});

export default store;

type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
